module.exports = __webpack_public_path__ + "media/images/bu_01-061f47a9b4b7e336092e1e3592aa4e98.jpg";